import * as React from 'react';
import IconBase, { type TIconBaseProps, Example as IconBaseExample } from '@atlas/uicorn/lib/Icon/IconBase';
import { defineMessages, useIntl } from '@atlas/text';

export const messages = defineMessages({
    info: { id: 'lblIconInfo', defaultMessage: 'Info' },
});

const InfoIcon = React.memo(function InfoIcon(props: TInfoIconProps): React.ReactElement {
    const intl = useIntl();

    return (
        <IconBase aria-label={intl.formatMessage(messages.info)} {...props}>
            <path
                clipRule="evenodd"
                fillRule="evenodd"
                d="M11 17.5a6.5 6.5 0 1 0 0-13 6.5 6.5 0 0 0 0 13Zm0 1.5a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm0-10.1a1.2 1.2 0 1 0 0-2.4 1.2 1.2 0 0 0 0 2.4Zm-.86 6.491c0 .06.078.109.172.109h1.375c.095 0 .172-.05.172-.109v-5.032c0-.06-.077-.109-.172-.109h-1.375c-.094 0-.172.05-.172.11v5.031Z"
            />
        </IconBase>
    );
});

export default InfoIcon;

// #region Types

export type TInfoIconProps = Omit<TIconBaseProps, 'children' | 'aria-label'> &
    Partial<Pick<TIconBaseProps, 'aria-label'>>;

// #endregion

// #region Examples

export const Example =
    typeof IconBaseExample === 'function' ? () => <InfoIcon /> : { ...IconBaseExample, render: InfoIcon };

// #endregion
